module.exports = __webpack_public_path__ + "static/media/loader.a3e12a01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loader.svg
// module id = 248
// module chunks = 12